<template>
  <TabBar activeTabName="customers" />
  <CustomerMainList />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import CustomerMainList from '@/components/fleet/CustomerMainList.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    CustomerMainList,
    TabBar
  }
})
export default class CustomersList extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Customers', '/#fleet', '')
  }
}
</script>
